import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { VideoPlayer as BaseVideoPlayer } from '@skooldio/skooldio-video-player';
import '@skooldio/skooldio-video-player/dist/skd-videojs.css';
// import 'skooldio-video-player/dist/video-js.6.10.min.css'; // default vjs styles

import { COLOR, theme } from '../Theme';

const VideoWrapper = styled.div`
  height: 320px;
  .video-js {
    font-family: inherit;
  }
  .video-js .vjs-slider.vjs-progress-holder .vjs-play-progress,
  .video-js .vjs-volume-bar.vjs-slider-vertical .vjs-volume-level {
    background-color: ${COLOR.primary};
  }
  /* icons */
  .video-js .vjs-button > .vjs-icon-placeholder:before {
    font-size: 2.2em;
  }
  /* time and playback speed text */
  .video-js .vjs-time-control,
  .video-js .vjs-playback-rate .vjs-playback-rate-value {
    font-size: 1.4em;
    font-weight: 400;
  }

  .video-js .vjs-seek-button {
    display: none;
  }

  @media (min-width: ${theme.breakpoints[0]}) {
    .video-js .vjs-seek-button {
      display: block;
    }
  }

  @media (min-width: ${theme.breakpoints[2]}) {
    .video-js .vjs-seek-button {
      display: none;
    }
  }
`;

class VideoPlayer extends Component {
  static propTypes = {
    autoplay: PropTypes.bool,
  };
  static defaultProps = {
    autoplay: false,
  };
  render() {
    const { wrapperStyle, autoplay, ...restProps } = this.props;
    const { DEFAULT_VIDEO_OPTIONS } = BaseVideoPlayer || {};
    const { controlBar, youtube } = DEFAULT_VIDEO_OPTIONS || {};
    const videoOptions = {
      controlBar: {
        children: [...controlBar.children, 'fullscreenToggle'],
      },
      autoplay,
      youtube: {
        ...youtube,
        modestbranding: 0,
        showinfo: 0,
        enablePrivacyEnhancedMode: 1, // this enable no cookies mode
      },
    };
    return (
      <VideoWrapper style={wrapperStyle}>
        <BaseVideoPlayer height="100%" videoOptions={videoOptions} {...restProps} />
      </VideoWrapper>
    );
  }
}

export default VideoPlayer;
